import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface PageHeaderProps {
    title: ReactNode;
    meta?: ReactNode;
    leading?: ReactNode;
    children?: ReactNode;
    wrap?: boolean;
    actionsGrow?: boolean;
}

export function PageMeta({ children }: { children: ReactNode }) {
    return (
        <Typography
            component="span"
            sx={{ fontSize: '12px', color: 'text.secondary' }}
        >
            {children}
        </Typography>
    );
}

export function PageHeader({
    title,
    meta,
    leading,
    children,
    wrap = false,
    actionsGrow = false,
}: PageHeaderProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                flexWrap: wrap ? 'wrap' : 'nowrap',
            }}
        >
            {leading}
            <Box sx={{ minWidth: 0, flex: actionsGrow ? '0 0 auto' : 1 }}>
                <Typography
                    sx={{
                        fontSize: '18px',
                        fontWeight: 700,
                        lineHeight: 1.25,
                    }}
                >
                    {title}
                </Typography>
                {meta && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            columnGap: 1.5,
                            rowGap: 0.25,
                            mt: 0.25,
                        }}
                    >
                        {meta}
                    </Box>
                )}
            </Box>
            {children}
        </Box>
    );
}
